import * as t from "ramda";
const r = (i) => !t.isNil(i) && !t.isEmpty(i);
export {
  r as isFullInviteCode
};
//# sourceMappingURL=index.js.map
